import { TrustCenterEventService, TrustCenterFacadeService } from '@anecdotes/shared-trust-center';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { SupportRequestService } from '@anecdotes/support';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-trust-empty-state',
  templateUrl: './trust-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrustEmptyStateComponent {
  @HostBinding('class')
  private readonly classes = 'flex h-full w-full';

  constructor(
    private trustCenterFacadeService: TrustCenterFacadeService,
    private supportRequestService: SupportRequestService,
    private trustCenterEventService: TrustCenterEventService,
    private translate: TranslateService,
  ) {}

  buildTranslationKey(relativeKey: string): string {
    return `trustCenter.emptyState.${relativeKey}`;
  }

  learnMoreAboutTrustCenter(): void {
    this.trustCenterFacadeService.openTrustCenterEditor();
  }

  contactUs(): void {
    this.trustCenterEventService.trackContactUsClick();
    
    this.supportRequestService.openTicketAsync({
      subject: this.translate.instant(this.buildTranslationKey('ticket.subject')),
      description: '',
    });
  }
}
